import React, { useState } from 'react';

const StarRating = ({ initialRating, onRatingChange, readOnly }) => {
    const [rating, setRating] = useState(initialRating || 0);
    const [hover, setHover] = useState(0);

    const handleRatingClick = (index) => {
        if (readOnly) return;
        setRating(index);
        if (onRatingChange) {
            onRatingChange(index);
        }
    };

    return (
        <div className="star-rating-container">
            {[...Array(5)].map((_, index) => {
                const starIndex = index + 1;
                return (
                    <span
                        key={starIndex}
                        className={`star${starIndex <= (hover || rating) ? ' active' : ''}${readOnly ? ' read-only' : ''}`}
                        onClick={() => handleRatingClick(starIndex)}
                        onMouseEnter={() => !readOnly && setHover(starIndex)}
                        onMouseLeave={() => !readOnly && setHover(rating)}
                        style={{ fontSize: readOnly ? '1.3rem' : '1.8rem' }}
                    >
                        &#9733;
                    </span>
                );
            })}
        </div>
    );
};

export default StarRating;